module.exports = __webpack_public_path__ + "static/banner-products-by-category-sorting-tabs-source-editor-71575cb566a2662baad15e74565955a4.png";